var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLockIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66665H13.3333C13.7015 6.66665 14 6.96511 14 7.33331V14C14 14.3682 13.7015 14.6666 13.3333 14.6666H2.66667C2.29848 14.6666 2 14.3682 2 14V7.33331C2 6.96511 2.29848 6.66665 2.66667 6.66665H3.33333V5.99998C3.33333 3.42265 5.42267 1.33331 8 1.33331C10.5773 1.33331 12.6667 3.42265 12.6667 5.99998V6.66665ZM11.3333 6.66665V5.99998C11.3333 4.15903 9.84093 2.66665 8 2.66665C6.15905 2.66665 4.66667 4.15903 4.66667 5.99998V6.66665H11.3333ZM7.33333 9.33331V12H8.66667V9.33331H7.33333Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LockIcon.637bdd48.svg";
export { ForwardRef as ReactComponent };